.question {
  gap: clamp(1.3rem, 3.4vh, 2.2rem);
  max-width: 40rem;
  /* center the column on screen, like the Reading step */
  margin: 0 auto;
}

.prompt {
  font-size: clamp(2rem, 6.5vw, 3rem);
  font-style: italic;
  font-weight: 400;
  color: var(--paper);
}

.field {
  position: relative;
  width: 100%;
  max-width: var(--measure);
}

.textarea {
  width: 100%;
  background: transparent;
  border: none;
  resize: none;
  text-align: center;
  font-family: var(--serif);
  font-size: clamp(1.15rem, 3vw, 1.5rem);
  line-height: 1.55;
  color: var(--paper);
  padding: 0.6rem 0.2rem;
  outline: none;
}

.textarea::placeholder {
  color: var(--paper-ghost);
  font-style: italic;
}

.underline {
  display: block;
  height: 1px;
  width: 100%;
  background: linear-gradient(90deg, transparent, var(--paper-ghost), transparent);
  transition: background 0.5s var(--ease-soft);
}
.field:focus-within .underline {
  background: linear-gradient(90deg, transparent, var(--gold-soft), transparent);
}

.chooser {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.7rem;
  width: 100%;
  max-width: var(--measure);
}

.legend {
  font-family: var(--sans);
  font-size: 0.72rem;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--paper-ghost);
}

.methods {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}

.method {
  flex: 1 1 12rem;
  text-align: center;
  border: 1px solid var(--paper-ghost);
  border-radius: 10px;
  padding: 0.95rem 1.15rem;
  background: transparent;
  transition:
    border-color 0.45s var(--ease-soft),
    background-color 0.45s var(--ease-soft),
    transform 0.45s var(--ease-soft);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.3rem;
  -webkit-tap-highlight-color: transparent;
}

.method:hover {
  border-color: var(--gold-soft);
}

.method.active {
  border-color: var(--cinnabar-soft);
  background: rgba(179, 71, 51, 0.07);
}

.methodName {
  font-family: var(--serif);
  font-size: 1.2rem;
  color: var(--paper);
}
.method.active .methodName {
  color: var(--paper);
}

.methodBlurb {
  font-family: var(--sans);
  font-size: 0.74rem;
  line-height: 1.4;
  letter-spacing: 0.01em;
  color: var(--paper-faint);
}

.sources {
  display: flex;
  gap: 0.6rem;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}

.source {
  border: 1px solid var(--paper-ghost);
  border-radius: 999px;
  padding: 0.4rem 0.95rem;
  background: transparent;
  font-family: var(--sans);
  font-size: 0.82rem;
  letter-spacing: 0.02em;
  color: var(--paper-faint);
  transition:
    border-color 0.45s var(--ease-soft),
    background-color 0.45s var(--ease-soft),
    color 0.45s var(--ease-soft);
  -webkit-tap-highlight-color: transparent;
}

.source:hover {
  border-color: var(--gold-soft);
}

.source.active {
  border-color: var(--cinnabar-soft);
  background: rgba(179, 71, 51, 0.07);
  color: var(--paper);
}

.source.locked {
  cursor: default;
  opacity: 0.85;
}

.source.locked:hover {
  border-color: var(--cinnabar-soft);
}

.hint {
  font-family: var(--sans);
  font-size: 0.72rem;
  line-height: 1.4;
  letter-spacing: 0.01em;
  color: var(--paper-faint);
  text-align: center;
}
